class ProductWarehouseStockCell extends UITableViewCell
{
    private nameLabel:MUILabel = null;
    private minTextField:MUITextField = null;
    private maxTextField:MUITextField = null;
    private valueTextField:MUITextField = null;
    private defaultSwitchButton:MUISwitchButton = null;

    private nf = MUIWebApplication.sharedInstance().delegate.numberFormatter as MIONumberFormatter;

    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");

        this.minTextField = MUIOutlet(this, "warehouse-min-tf", "MUITextField");
        if (this.minTextField) this.minTextField.setOnChangeText(this, function(control:MUITextField, value:string){
            let q = this.nf.numberFromString(value);
            this._productWarehouse.minQuantity = q;
        });

        this.maxTextField = MUIOutlet(this, "warehouse-max-tf", "MUITextField");        
        if (this.maxTextField) this.maxTextField.setOnChangeText(this, function(control:MUITextField, value:string){            
            let q = this.nf.numberFromString(value);
            this._productWarehouse.maxQuantity = q;
        });

        this.valueTextField = MUIOutlet(this, "value-tf", "MUITextField");
        if (this.valueTextField) this.valueTextField.setOnChangeText(this, function(this:ProductWarehouseStockCell, control:MUITextField, value:string){
            this.updatePWLValue( value.length ? value : null );
        });

        // this.defaultSwitchButton = MUIOutlet(this, 'default-switch','MUISwitchButton');
        // this.defaultSwitchButton.setOnChangeValue(this, function(control, value){
        //     this._productWarehouse.isDefault = value;
        // });  

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:any = null;
    set item(item:any){        

        if (item["Type"] == "PW") {
            this._item = item;
            let pw:ProductWarehouse = item["PW"];
            this.updatePW(pw);
        }
        else if (item["Type"] == "WL") {
            this._item = item;
            let wl:WarehouseLocation = item["WL"];
            this.updatePWL(wl, item["PWL"] );
        }
    }    

    private updatePW( pw:ProductWarehouse) {
        if (pw.warehouse == null) {
            this.nameLabel.text = MIOLocalizeString("WAREHOUSE_DELETED", "WAREHOUSE DELETED");
        } else {
            this.nameLabel.text = pw.warehouse.name;
            this.minTextField.text = pw.minQuantity;
            this.maxTextField.text = pw.maxQuantity;
            // this.defaultSwitchButton.on = item.isDefault;
        }
    }

    private updatePWL( wl:WarehouseLocation, pwl:ProductWarehouseLocation|null) {
        this.nameLabel.text = wl.name;
        this.valueTextField.text = pwl?.value;
    }

    private updatePWLValue( value:string|null ) {
        if (this._item["PWL"] == null) {
            let pwl = MIOEntityDescription.insertNewObjectForEntityForName("ProductWarehouseLocation", MUIWebApplication.sharedInstance().delegate.managedObjectContext) as ProductWarehouseLocation;
            pwl.product = this._item["P"];
            pwl.warehouse = this._item["WL"].warehouse;
            pwl.warehouseLocation = this._item["WL"];
            this._item["PWL"] = pwl;
        } 
        
        this._item["PWL"].value = value;
    }

}